import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SummaryPageComponent } from '../summary-page/summary-page.component';
import { ProjectsComponent } from '../projects/projects.component';
import { MyTaskComponent } from '../my-task/my-task.component';
import { ReportsComponent } from '../reports/reports.component';
import { EditSalesOrderComponent } from '../projects/edit-sales-order/edit-sales-order.component';
import { ManfPlanComponent } from '../projects/manf-plan/manf-plan.component';
import { MastPlanComponent } from '../projects/mast-plan/mast-plan.component';
import { DownloadsComponent } from '../projects/downloads/downloads.component';
import { MastPlanV2Component } from '../projects/mast-plan-v2/mast-plan-v2.component';
import {MastPlanV3Component} from '../projects/mast-plan-v3/mast-plan-v3.component';
import {DelMastPlanComponent} from '../projects/del-mast-plan/del-mast-plan.component';
import {DelSubMastPlanComponent} from '../projects/del-sub-mast-plan/del-sub-mast-plan.component';
import { ReviewPageComponent } from '../review-page/review-page.component';
import { KpisComponent } from '../reports/kpis/kpis.component';
import { KpisV2Component } from '../reports/kpis-v2/kpis-v2.component';
import { KpiExcelComponent } from '../reports/kpi-excel/kpi-excel.component';
import { GanttSummaryComponent } from '../reports/gantt-summary/gantt-summary.component';
import { KpisV3Component } from '../reports/kpis-v3/kpis-v3.component';
import { KpisV4Component } from '../reports/kpis-v4/kpis-v4.component';
import { KpisV5Component } from '../reports/kpis-v5/kpis-v5.component';

export const routes: Routes = [
  {
    path:'summary',component:SummaryPageComponent,pathMatch:'full'
  },
  {
    path:'review',component:ReviewPageComponent,pathMatch:'full'
  },
  {
    path: 'reports', component: ReportsComponent, children: [
      {
        path: 'kpis', component: KpisComponent
      },
      {
        path: 'kpisv2', component: KpisV2Component
      },
      {
        path: 'excel', component: KpiExcelComponent
      },
      {
        path: 'ganttsummary', component: GanttSummaryComponent
      },
      {
        path: 'kpisv3', component: KpisV3Component
      },
      {
        path: 'kpisv4', component: KpisV4Component
      },
      {
        path: 'kpisv5', component: KpisV5Component
      }
    ]
  },
  
  {
    path:'projects',component:ProjectsComponent,children:[
        {
            path:'new',component:EditSalesOrderComponent
        },
        {
          path:'manfplan',component:ManfPlanComponent
        },
        {
          path:'mastplan',component:MastPlanComponent
        },
        {
          path:'mastplanv2',component:MastPlanV2Component
        },
        {
          path:'mastplanv3',component:MastPlanV3Component
        },
        {
          path:'delmastplan',component:DelMastPlanComponent
        },
        {
          path:'delsubmastplan',component:DelSubMastPlanComponent
        },
        {
          path:'downloads',component:DownloadsComponent
        }
    ]
  },
  {
    path:'sales',component:ProjectsComponent,children:[
        {
            path:'edit/:soid',component:EditSalesOrderComponent
        },
        {
          path:'edit/:soid/:somodule/:subsono',component:EditSalesOrderComponent
        }
    ]
  },
  //{ path: 'sales/edit/:soid', component: EditSalesOrderComponent },
  //{ path: 'sales/edit/:soid/:somodule/:subsono', component: EditSalesOrderComponent },
  { path: 'mytask', component:MyTaskComponent, pathMatch: 'full'},
  { path: 'reports', component:ReportsComponent, pathMatch: 'full'},
  //{ path: '', redirectTo: 'projects/new', pathMatch: 'full'}
  { path: '', redirectTo: 'summary', pathMatch: 'full'}
  //{ path: '', redirectTo: 'projects/mastplan', pathMatch: 'full'}
  
]; 
@NgModule({
  imports: [BrowserModule,FormsModule,RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }
